import { getAuthToken, getStaff } from "../components/auth-utils";


const user = getStaff();
const token = getAuthToken();
const school = localStorage.getItem('school') !== undefined ? JSON.parse(localStorage.getItem('school')) : null;
const jspPrimary = localStorage.getItem('jsp-primary');
const permissions = localStorage.getItem('jsp_staff_permissions') != undefined ? JSON.parse(localStorage.getItem('jsp_staff_permissions')) : [];
const jspTheme = localStorage.getItem('theme');

let jspStaffPermissions = [];
const environment = window.location.hostname;

let host;


if (environment === 'localhost' || environment === 'eum.tespire.co' || environment === 'uni-staging.tespire.co') {
  host = 'https://api-staging.tespire.ng';
} else {
  host = 'https://api.tespire.ng';
}


permissions !== null && permissions.forEach((permission) => jspStaffPermissions.push(permission.name));

const data = {
  school: school,
  staff: user != undefined ? user : '',
  jspPrimary: jspPrimary,
  theme: jspTheme,
  jspStaffPermissions: jspStaffPermissions,
  host: host,
  // cloud: 'https://filesupload.jdlabserver.com',
  // printHost: 'https://www.jsp.ng/',
  token: token != undefined ? token : '',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token != undefined ? token : ''}`,
    xtenant: environment === 'localhost' ? 'uni-staging.tespire.co' : environment
  }
};

export default data;
